import React from 'react'
import {
    HashRouter as Router,
    Route,
    Link,
    Redirect
} from 'react-router-dom'
import {Button, Horizontal, Image, Vertical} from "../../components/index";
import IndexScreen from "./screens/IndexScreen";
import ManuscriptDetailScreen from "./screens/ManuscriptDetailScreen";

class App extends React.Component {
    render() {
        return (
            <div className={'App'}>
                <Router>
                    <Vertical >
                        <Route path="/:_id"
                               component={IndexScreen}/>
                    </Vertical>
                </Router>
            </div>
        );
    }
}


export default App




// WEBPACK FOOTER //
// ./src/apps/portfolio/App.js